import React from 'react'
import { AIContextState, initialAIContextState } from './state'
import { AIContextActions } from './actions'

export const AIContextContext = React.createContext<{
  state: AIContextState
  dispatch: React.Dispatch<AIContextActions>
}>({
  state: initialAIContextState,
  dispatch: () => undefined,
})
